import type { Season } from '~/src/common/lean-back';

export function getNextEpisodeDate(
  season: Season | null,
): Season['next_episode_release_date'] | null {
  return season?.next_episode_release_date || null;
}
